var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.875a1.595 1.595 0 1 0-2.742 1.107c-1.085 2.247-3.16 3.031-4.766 2.321-1.432-.633-1.96-2.443-2.139-3.845A1.833 1.833 0 0 0 10.5 0a1.834 1.834 0 0 0-.853 3.458C9.468 4.86 8.94 6.67 7.508 7.303c-1.607.71-3.68-.074-4.766-2.32a1.595 1.595 0 1 0-1.353.474l1.84 6.728h14.543l1.839-6.73A1.595 1.595 0 0 0 21 3.876ZM18.663 15.056c0 .655-.532 1.187-1.188 1.187H3.525a1.187 1.187 0 0 1-1.187-1.187v-.099c0-.656.531-1.188 1.187-1.188h13.95c.656 0 1.188.532 1.188 1.188v.099Z",
    fill: "#4B4B4B"
  })));
};
export default SvgCrown;